import script from "./QueueActivitiesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QueueActivitiesPage.vue?vue&type=script&setup=true&lang=ts"

import "./QueueActivitiesPage.vue?vue&type=style&index=0&id=f0360c74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0360c74"]])

export default __exports__